"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = void 0;

var constants_1 = require("./constants");

function prependIdToSelectorText(selectorText, id) {
  if (!id) return selectorText;
  return selectorText.split(',').map(function (selector) {
    return selector.trim();
  }).map(function (selector) {
    var s = selector.replace(/\./g, '.' + id + '_').replace(/#/g, '#' + id + '_');

    if (s.toLowerCase().startsWith('body')) {
      return '#' + id + ' ' + s.substring(4);
    } else {
      return '#' + id + ' ' + s;
    }
  }).join(',');
}

function sanitizeCssValue(cssValue, allowedSchemas, rewriteExternalResources) {
  return cssValue.trim().replace(/expression\((.*?)\)/g, '').replace(/url\(["']?(.*?)["']?\)/g, function (match, url) {
    var quote = '';

    if (match.startsWith('url("')) {
      quote = '"';
    } else if (match.startsWith("url('")) {
      quote = "'";
    }

    if (allowedSchemas.includes(url.toLowerCase().split(':')[0])) {
      if (rewriteExternalResources) {
        return 'url(' + quote + rewriteExternalResources(url) + quote + ')';
      } else {
        return match;
      }
    } else {
      return '';
    }
  });
}

function sanitizeCssStyle(style, allowedSchemas, preserveCssPriority, rewriteExternalResources) {
  if (!style) {
    return;
  }

  var properties = [];

  for (var i = 0; i < style.length; i++) {
    var name = style[i];
    properties.push(name);
  }

  for (var _i = 0, _properties = properties; _i < _properties.length; _i++) {
    var _name = _properties[_i];

    if (constants_1.allowedCssProperties.includes(_name)) {
      var value = style.getPropertyValue(_name);
      style.setProperty(_name, sanitizeCssValue(value, allowedSchemas, rewriteExternalResources), preserveCssPriority ? style.getPropertyPriority(_name) : undefined);
    } else {
      style.removeProperty(_name);
    }
  }
}

function sanitizeCssRule(rule, id, allowedSchemas, preserveCssPriority, rewriteExternalResources) {
  rule.selectorText = prependIdToSelectorText(rule.selectorText, id);
  sanitizeCssStyle(rule.style, allowedSchemas, preserveCssPriority, rewriteExternalResources);
}

var defaultAllowedSchemas = ['http', 'https', 'mailto'];

function sanitizeHtml(input, _ref) {
  var _ref$dropAllHtmlTags = _ref.dropAllHtmlTags,
      dropAllHtmlTags = _ref$dropAllHtmlTags === void 0 ? false : _ref$dropAllHtmlTags,
      rewriteExternalLinks = _ref.rewriteExternalLinks,
      rewriteExternalResources = _ref.rewriteExternalResources,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'msg_' + String.fromCharCode.apply(String, _toConsumableArray(new Array(24).fill(undefined).map(function () {
    return Math.random() * 25 % 25 + 65;
  }))) : _ref$id,
      _ref$allowedSchemas = _ref.allowedSchemas,
      allowedSchemas = _ref$allowedSchemas === void 0 ? defaultAllowedSchemas : _ref$allowedSchemas,
      _ref$preserveCssPrior = _ref.preserveCssPriority,
      preserveCssPriority = _ref$preserveCssPrior === void 0 ? true : _ref$preserveCssPrior,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === void 0 ? false : _ref$noWrapper;

  var _a, _b, _c, _d, _e, _f, _g, _h;

  if (noWrapper) id = '';
  var doc = new DOMParser().parseFromString(input, 'text/html'); // Ensure allowed schemas are lower case.

  allowedSchemas = Array.isArray(allowedSchemas) ? allowedSchemas.map(function (schema) {
    return schema.toLowerCase();
  }) : defaultAllowedSchemas; // Remove comments.

  var commentIter = doc.createNodeIterator(doc.documentElement, NodeFilter.SHOW_COMMENT);
  var node;

  while (node = commentIter.nextNode()) {
    (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(node);
  }

  var removeTags = _toConsumableArray(constants_1.removeWithContents);

  if (dropAllHtmlTags) {
    removeTags.push('style');
  } // Remove disallowed tags.


  var disallowedList = doc.querySelectorAll(removeTags.join(', '));
  disallowedList.forEach(function (element) {
    return element.remove();
  }); // Move styles from head to body.

  var styleList = doc.querySelectorAll('head > style');
  styleList.forEach(function (element) {
    doc.body.appendChild(element);
  }); // Filter other tags.

  var toRemove = [];
  var elementIter = doc.createNodeIterator(doc.body, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode() {
      return NodeFilter.FILTER_ACCEPT;
    }
  });

  while (node = elementIter.nextNode()) {
    var element = node;
    var tagName = element.tagName.toLowerCase();

    if (tagName === 'body' || tagName === 'html') {
      continue;
    }

    if (dropAllHtmlTags) {
      if (node.textContent) {
        var textNode = doc.createTextNode(node.textContent);
        (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.replaceChild(textNode, node);
      } else {
        (_c = node.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(node);
      }

      continue;
    }

    if (tagName in constants_1.allowedTags) {
      var allowedAttributes = constants_1.allowedTags[tagName];

      var _iterator = _createForOfIteratorHelper(element.getAttributeNames()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attribute = _step.value;

          if (!allowedAttributes.includes(attribute)) {
            element.removeAttribute(attribute);
          } else if (attribute === 'class' && !noWrapper) {
            element.setAttribute(attribute, (_e = (_d = element.getAttribute(attribute)) === null || _d === void 0 ? void 0 : _d.split(' ').map(function (className) {
              return id + '_' + className;
            }).join(' ')) !== null && _e !== void 0 ? _e : '');
          } else if (attribute === 'id' && !noWrapper) {
            element.setAttribute(attribute, id + '_' + ((_f = element.getAttribute(attribute)) !== null && _f !== void 0 ? _f : ''));
          } else if (attribute === 'href' || attribute === 'src') {
            var value = (_g = element.getAttribute(attribute)) !== null && _g !== void 0 ? _g : '';

            if (!allowedSchemas.includes(value.toLowerCase().split(':')[0])) {
              element.removeAttribute(attribute);
            } else if (attribute === 'href' && rewriteExternalLinks) {
              element.setAttribute(attribute, rewriteExternalLinks(value));
            } else if (attribute === 'src' && rewriteExternalResources) {
              element.setAttribute(attribute, rewriteExternalResources(value));
            }
          }
        } // Sanitize CSS.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      sanitizeCssStyle(element.style, allowedSchemas, preserveCssPriority, rewriteExternalResources);

      if (tagName === 'a') {
        // Add rel="noopener noreferrer" to <a>
        element.setAttribute('rel', 'noopener noreferrer'); // Add target="_blank" to <a>

        element.setAttribute('target', '_blank');
      }
    } else {
      element.insertAdjacentHTML('afterend', element.innerHTML);
      toRemove.push(element);
    }
  }

  for (var _i2 = 0, _toRemove = toRemove; _i2 < _toRemove.length; _i2++) {
    var _element = _toRemove[_i2];

    try {
      try {
        (_h = _element.parentNode) === null || _h === void 0 ? void 0 : _h.removeChild(_element);
      } catch (_j) {
        _element.outerHTML = '';
      }
    } catch (_k) {
      try {
        _element.remove();
      } catch (_l) {}
    }
  } // Prepend wrapper ID.


  var bodyStyleList = doc.querySelectorAll('body style');
  bodyStyleList.forEach(function (element) {
    var styleElement = element;
    var stylesheet = styleElement.sheet;
    var newRules = [];

    if (!stylesheet.cssRules) {
      styleElement.textContent = '';
      return;
    }

    for (var i = 0; i < stylesheet.cssRules.length; i++) {
      var rule = stylesheet.cssRules[i];

      if ('selectorText' in rule) {
        sanitizeCssRule(rule, id, allowedSchemas, preserveCssPriority, rewriteExternalResources);
        newRules.push(rule);
      } else if ('cssRules' in rule && 'media' in rule) {
        // According to https://www.caniemail.com/,
        // out of all at-rules, Gmail only supports @media.
        var mediaRule = rule;
        var newRulesMedia = [];

        for (var _i3 = 0; _i3 < mediaRule.cssRules.length; _i3++) {
          var _rule = mediaRule.cssRules[_i3];

          if (_rule.type === _rule.STYLE_RULE) {
            sanitizeCssRule(_rule, id, allowedSchemas, preserveCssPriority, rewriteExternalResources);
            newRulesMedia.push(_rule);
          }
        }

        while (mediaRule.cssRules.length > 0) {
          mediaRule.deleteRule(0);
        }

        for (var _i4 = 0, _newRulesMedia = newRulesMedia; _i4 < _newRulesMedia.length; _i4++) {
          var _rule2 = _newRulesMedia[_i4];
          mediaRule.insertRule(_rule2.cssText, mediaRule.cssRules.length);
        }

        newRules.push(mediaRule);
      }
    }

    styleElement.textContent = newRules.map(function (rule) {
      return rule.cssText;
    }).join('\n');
  }); // Wrap body inside of a div with the generated ID.

  if (noWrapper) {
    return doc.body.innerHTML;
  } else {
    var div = doc.createElement('div');
    div.id = id;
    div.innerHTML = doc.body.innerHTML;
    return div.outerHTML;
  }
}

function sanitizeText(text) {
  var div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function sanitize(html, text, options) {
  var contents = html !== null && html !== void 0 ? html : '';

  if ((contents === null || contents === void 0 ? void 0 : contents.length) === 0 && text) {
    contents = sanitizeText(text).split('\n').map(function (line) {
      return '<p>' + line + '</p>';
    }).join('\n');
  }

  return sanitizeHtml(contents, options !== null && options !== void 0 ? options : {});
}

exports.sanitize = sanitize;